import script from "./ScriptErrorFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ScriptErrorFilter.vue?vue&type=script&setup=true&lang=js"

import "./ScriptErrorFilter.vue?vue&type=style&index=0&id=70e0429b&scoped=true&lang=scss"

import exportComponent from "D:\\DongLK\\Project\\ytbot\\controller-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e0429b"]])

export default __exports__